// @flow

import React, {useEffect} from "react";
import Loading from "../layout/Loading";
import type BrandInstance from "../../models/Brand";
import {withTranslation} from "react-i18next";
import type {translate} from "../../i18next";
import "./BrandInstance.scss";
import Placeholder2x1 from "../../assets/ph2x1.png";
import type {GarageDealership} from "../../models/GarageDealership";

export type BrandInstanceProps = {
    shouldRender: boolean,
    brandInstances?: GarageDealership[],
    autoselectedInstance: GarageDealership,
    disableConfig: () => void,
    selectBrand: number => void,
    t: translate,
}

const BrandInstancePage = ({
                               autoselectedInstance,
                               brandInstances,
                               selectBrand,
                               shouldRender,
                               t
                           }: BrandInstanceProps) => {

    useEffect(() => {
        if (autoselectedInstance) {
            selectBrand(autoselectedInstance);
        }
    }, [autoselectedInstance, selectBrand, brandInstances]);

    const renderBrands = (brands?: BrandInstance[]) => {
        if (brands === null) return;
        return brands.map((brand, index) => {
            const brandLogo = {
                backgroundImage: `url(${brand.manufacturerLogoUrl})`
            };
            const brandSize = {
                flex: brands.length <= 4
                    ? "0 0 45%"
                    : brands.length <= 6
                        ? "0 0 30%"
                        : "unset"
            };
            return (
                <button key={index} className="hpm-brand"
                        onClick={() => selectBrand(brand)}
                        onKeyDown={e => {
                            if (e.key === "Enter" || e.key === " ") {
                                selectBrand(brand);
                            }
                        }}
                        aria-label={brand.manufacturerName}
                        tabIndex={0}
                        style={brandSize}>
                    <img src={Placeholder2x1} role={"presentation"} alt=""/>
                    <div className="hpm-brandLogo" style={brandLogo}/>
                </button>
            );
        });
    };

    if (brandInstances === null) {
        return <Loading/>;
    }

    return shouldRender
        ? <div className="hpm-brand-instance">
            {brandInstances.length
                ? <>
                    <div className="hpm-brand-title">{t("brandSelector.title")}</div>
                    <div className="hpm-brands">
                        {renderBrands(brandInstances)}
                    </div>
                </>
                : <div className="hpm-brand-title">{t("brandSelector.noBrands")}</div>
            }
        </div>
        : <Loading/>;
};

export default withTranslation()(BrandInstancePage);
